import { IStep } from "interfaces"
import { inRange } from "lodash"
import { useEffect, useRef } from "react"
import {
  gtmPushSurveyNavigationEXP,
  gtmPushSurveyNavigationEXPIncomplete,
} from "utils/googletagmanager"

export interface IUseStepTrackingProps {
  currentStep: number
  steps: IStep[]
  enabled?: boolean
}

export type UseStepTracking = (props: IUseStepTrackingProps) => void

export const useStepTracking: UseStepTracking = ({
  currentStep,
  steps,
  enabled = false,
}) => {
  const isFinalStep = useRef(false)
  const hasTriggered = useRef(false)
  const isIncompleteNavigation = useRef(false)

  isFinalStep.current = enabled ? currentStep === steps.length : false

  // Set navigation as incomplete if the current step is in the second half of the total steps.
  isIncompleteNavigation.current = enabled
    ? inRange(currentStep, Math.floor(steps.length / 2), steps.length)
    : false

  // If navigation was completed, also show the Navigation Experience Survey.
  useEffect(() => {
    if (!hasTriggered.current && isFinalStep.current) {
      gtmPushSurveyNavigationEXP()
      hasTriggered.current = true
    }
  }, [currentStep])

  // If navigation was not completed, show the Navigation Experience Survey.
  useEffect(() => {
    return () => {
      if (!hasTriggered.current && isIncompleteNavigation.current) {
        gtmPushSurveyNavigationEXPIncomplete()
        hasTriggered.current = true
      }
    }
  }, [])

  return
}
